import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ContactsComponent } from '../components/account-details/contacts/contacts.component';
import { CompanyComponent } from '../components/account-details/company/company.component';
import { AccountDetailsComponent } from '../components/account-details/account-details.component';
import { NewContactComponent } from '../components/account-details/contacts/new-contact/new-contact.component';
import { EditContactComponent } from '../components/account-details/contacts/edit-contact/edit-contact.component';
import { ContactRemoveComponent } from '../components/account-details/contacts/contact-remove/contact-remove.component';

import {
  AuthGuardService,
  AuthGuardNoAccountsService,
  AuthCallbackComponent,
  LoginComponent,
  RequestNewPasswordComponent,
  LogoutCallbackComponent,
  SetNewPasswordComponent,
  SignUpComponent,
} from 'common';

import { CompanyResolver } from '../resolvers/company.resolver';
import { EditContactResolver } from '../resolvers/edit-contact.resolver';
import { ContactsResolver } from '../resolvers/contacts.resolver';
import { SalutationResolver } from '../resolvers/salutation.resolver';
import { CountryResolver } from '../resolvers/country.resolver';
import { CountyResolver } from '../resolvers/county.resolver';
import { OrganisationTypeResolver } from '../resolvers/organisation-type.resolver';
import { ManageProfileComponent } from '../components/profile/manage-profile/manage-profile.component';
import { PermissionsResolver } from '../resolvers/permissions.resolver';
import { PermissionsComponent } from '../components/account-details/permissions/permissions.component';
import { RegistrationComponent } from '../components/registration/registration.component';
import { RegistrationSalutationResolver } from '../resolvers/registration-salutation.resolver';
import { PendingAccountRegistrationResolver } from '../resolvers/pending-account-registration.resolver';

const routes: Routes = [
  {
    path: 'accounts',
    canActivate: [AuthGuardService],
    component: AccountDetailsComponent,
    pathMatch: 'full',
  },
  {
    path: 'accounts/registration',
    component: RegistrationComponent,
    pathMatch: 'full',
    canActivate: [AuthGuardNoAccountsService],
    resolve: {
      salutations: RegistrationSalutationResolver,
      countries: CountryResolver,
      counties: CountyResolver,
      prsOrganisationTypes: OrganisationTypeResolver,
    },
  },
  {
    path: 'login',
    component: LoginComponent,
    pathMatch: 'full',
  },
  {
    path: 'auth-callback',
    component: AuthCallbackComponent,
    pathMatch: 'full',
  },
  {
    path: 'logout-callback',
    component: LogoutCallbackComponent,
    pathMatch: 'full',
  },
  {
    path: 'password/reset',
    component: RequestNewPasswordComponent,
    pathMatch: 'full',
  },
  {
    path: 'password/set',
    component: SetNewPasswordComponent,
    pathMatch: 'full',
  },
  {
    path: 'profile',
    component: ManageProfileComponent,
    pathMatch: 'full',
    resolve: {
      pendingAccountRegistrations: PendingAccountRegistrationResolver,
    },
  },
  {
    path: 'sign-up',
    component: SignUpComponent,
    data: { bannerKey: 'sign-up' },
    pathMatch: 'full',
  },
  {
    path: 'details',
    canActivate: [AuthGuardService],
    component: AccountDetailsComponent,
    children: [
      {
        path: 'company',
        component: CompanyComponent,
        pathMatch: 'full',
        resolve: {
          company: CompanyResolver,
          organisationTypes: OrganisationTypeResolver,
          salutations: SalutationResolver,
          countries: CountryResolver,
          counties: CountyResolver,
        },
      },
      {
        path: 'contacts',
        children: [
          {
            path: '',
            component: ContactsComponent,
            pathMatch: 'full',
            resolve: {
              contacts: ContactsResolver,
              permissions: PermissionsResolver,
            },
          },
          {
            path: 'new',
            component: NewContactComponent,
            pathMatch: 'full',
            resolve: {
              contacts: ContactsResolver,
              salutations: SalutationResolver,
              countries: CountryResolver,
              counties: CountyResolver,
              permissions: PermissionsResolver,
            },
          },
          {
            path: 'edit/:lcAuto',
            component: EditContactComponent,
            pathMatch: 'full',
            resolve: {
              contacts: ContactsResolver,
              contact: EditContactResolver,
              salutations: SalutationResolver,
              countries: CountryResolver,
              counties: CountyResolver,
              permissions: PermissionsResolver,
            },
          },
          {
            path: 'remove',
            component: ContactRemoveComponent,
            pathMatch: 'full',
          },
        ],
      },
      {
        path: 'permissions',
        component: PermissionsComponent,
        pathMatch: 'full',
        resolve: {
          contacts: ContactsResolver,
          permissions: PermissionsResolver,
        },
      },
    ],
  },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AccountsRoutingModule {}
